// Vue sets a function ref to null when the input unmounts. inputElements can
// therefore be [null] while the DynamicForm instance is still alive.

export function focusFirstInput(inputElements) {
    if (!Array.isArray(inputElements)) return false;
    for (const el of inputElements) {
        const input = el?.inputElement;
        if (typeof input?.focus === "function") {
            input.focus();
            return true;
        }
    }
    return false;
}

export function formIsUsable(form) {
    if (!form || typeof form.toggle !== "function") return false;
    const mounted = form.isMounted;
    if (mounted && typeof mounted === "object" && "value" in mounted) {
        return mounted.value !== false;
    }
    return mounted !== false;
}
